import { StringTMap } from '@@types/common';

import page from 'page';
import QS from 'qs';

type IParams = { channelId: string; imageId: string };

type IQuery = { forwardLogId: string; forwardLogChannelId: string };

const router = {
  initialize(routes: StringTMap<(params: IParams, query: IQuery) => void>) {
    page('*', (ctx, next) => {
      ctx.query = QS.parse(window.location.search.slice(1));
      next();
    });
    Object.keys(routes).forEach((url: string) => {
      page(url, ({ params, query }) => routes[url](params, query));
    });
    page.base('/messenger');
    page.start();
  },
  open: (url: string) => page.show(url),
  navigate: (url: string) => page(url),
  redirect: (url: string) => page.redirect(url),
};

export default router;
